import Price from '~/utils/Price/Price';
import { ProductPrice } from '~/Product';

export default class PublicReferencePrice {
	sourcePrice: ProductPrice;

	convertedPrice: Price;

	constructor(sourcePrice: ProductPrice, convertedPrice: Price) {
		this.sourcePrice = sourcePrice;
		this.convertedPrice = convertedPrice;
	}
}
